module.exports = __webpack_public_path__ + "img/research.ff1989db.svg";